import { Row, Col, Button, Table, Nav } from "react-bootstrap";
import useSWR from "swr";
import AuthenticatedWrapper from "../../components/wrapper";
import { fetcher, serverUrl, swrConfig } from "../../helpers/utility";
import { useNavigate } from "react-router-dom";
import variables from "../../styles/utils.module.scss";
import styles from "../../styles/provider.module.scss";
import { useCallback, useState } from "react";
import axios from "axios";
import { format, isToday } from "date-fns";
import { APPROVED, IN_REVIEW, REJECTED } from "../../helpers/constants";
import NavigationBack from "../../components/NavigationBack";

function AdminLocation({ user }) {
  const STEPS = {
    ACTIVE: "ACTIVE",
    IN_REVIEW: "IN_REVIEW",
    REJECTED: "REJECTED",
  };
  const navigate = useNavigate();
  const [step, setStep] = useState(STEPS.ACTIVE);

  if (user?.staffUser === false) {
    window.location.href = "https://www.bplaced.co.uk";
  }

  const {
    data: ownLocationData,
    error: locationError,
    isLoading: locationIsLoading,
  } = useSWR(`${serverUrl}/location?draft=true`, fetcher, swrConfig);

  const activeLocations = useCallback(() => {
    if (ownLocationData && ownLocationData.locations?.length > 0) {
      let approvedLocations = ownLocationData.locations?.filter((location) => {
        return location.status === APPROVED;
      });

      return approvedLocations;
    } else {
      return [];
    }
  }, [ownLocationData]);

  const pendingLocations = useCallback(() => {
    if (ownLocationData && ownLocationData.locations?.length > 0) {
      let unapprovedLocations = ownLocationData.locations?.filter((location) => {
        console.log(location.status);
        return location.status === IN_REVIEW;
      });

      return unapprovedLocations;
    } else {
      return [];
    }
  }, [ownLocationData]);

  const rejectedLocations = useCallback(() => {
    if (ownLocationData && ownLocationData.locations?.length > 0) {
      let rejectedLocationList = ownLocationData.locations?.filter((location) => {
        console.log(location.status);
        return location.status === REJECTED;
      });

      return rejectedLocationList;
    } else {
      return [];
    }
  }, [ownLocationData]);

  const goToLocation = useCallback(
    ({ locationId }) => {
      navigate(
        `/add-location?locationId=${locationId}&back=${encodeURIComponent("/admin/location")}`
      );
    },
    [navigate]
  );

  return (
    <AuthenticatedWrapper user={user}>
      <NavigationBack />

      <div style={{ marginTop: "0px", padding: "10px 0px 15px" }}>
        <Nav variant="tabs" defaultActiveKey="/home">
          <Nav.Item>
            <Nav.Link
              onClick={() => {
                console.log(`Review`);
                setStep(STEPS.IN_REVIEW);
              }}
              active={step === STEPS.IN_REVIEW}
            >
              In Review
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              onClick={() => {
                console.log(`Active`);
                setStep(STEPS.ACTIVE);
              }}
              active={step === STEPS.ACTIVE}
            >
              Active
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link
              onClick={() => {
                console.log(`Rejected`);
                setStep(STEPS.REJECTED);
              }}
              active={step === STEPS.REJECTED}
            >
              Rejected
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Row style={{ marginTop: 15 }}>
          <Col lg={6}>
            {/* ACTIVE Locations */}
            {step === STEPS.ACTIVE && activeLocations() ? (
              <Row style={{ marginTop: 0 }}>
                <Col lg={12}>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Location</th>
                        <th>Contact</th>
                        <th style={{ width: "75px" }}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {activeLocations().map((location) => {
                        return (
                          <tr
                            key={location._id}
                            onClick={() => {
                              goToLocation({ locationId: location._id });
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <td>
                              {location.name}
                              {!location.subscriptionActive ? (
                                <i
                                  className={`bi bi-exclamation-circle`}
                                  style={{
                                    fontSize: "14px",
                                    marginLeft: 6,
                                  }}
                                  title={`No active subscription`}
                                ></i>
                              ) : null}
                            </td>
                            <td>{location.email}</td>
                            <td style={{ textAlign: "left" }}>
                              <i
                                className={`bi bi-pencil`}
                                style={{
                                  fontSize: "14px",
                                  color: variables.green,
                                  padding: "3px",
                                  marginRight: "6px",
                                  cursor: "pointer",
                                }}
                                onClick={(event) => {
                                  goToLocation({ locationId: location._id });
                                  event.stopPropagation();
                                }}
                              ></i>

                              <i
                                className={`bi bi-search`}
                                style={{
                                  fontSize: "14px",
                                  color: variables.green,
                                  padding: "3px",
                                  cursor: "pointer",
                                }}
                                onClick={() => {
                                  // goToPlacementSearch({ placementId: location._id });
                                }}
                              ></i>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            ) : null}

            {/* Rejected Locations */}
            {step === STEPS.IN_REVIEW && pendingLocations()?.length > 0 ? (
              <Row>
                <Col lg={12}>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Location</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pendingLocations().map((location) => {
                        return (
                          <tr
                            key={location._id}
                            onClick={() => {
                              goToLocation({ locationId: location._id });
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <td>{location.name}</td>
                            <td>
                              {isToday(location.created)
                                ? "Today"
                                : format(location.created, "dd/MM/yyyy")}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>

                <Col lg={6} xl={5}></Col>
              </Row>
            ) : null}

            {/* Rejected Locations */}
            {step === STEPS.REJECTED && rejectedLocations()?.length > 0 ? (
              <Row>
                <Col lg={12}>
                  <Table striped bordered hover responsive>
                    <thead>
                      <tr>
                        <th>Location</th>
                        <th>Created</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rejectedLocations().map((location) => {
                        return (
                          <tr
                            key={location._id}
                            onClick={() => {
                              goToLocation({ locationId: location._id });
                            }}
                            style={{
                              cursor: "pointer",
                            }}
                          >
                            <td>{location.name}</td>
                            <td>
                              {isToday(location.created)
                                ? "Today"
                                : format(location.created, "dd/MM/yyyy")}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                </Col>

                <Col lg={6} xl={5}></Col>
              </Row>
            ) : null}
          </Col>
        </Row>
      </div>
    </AuthenticatedWrapper>
  );
}

export default AdminLocation;
